import {
  $debug,
  backButton,
  initData,
  init as initSDK,
  miniApp,
  themeParams,
  viewport
} from '@telegram-apps/sdk-react'

export function init(debug: boolean): void {
  $debug.set(debug)

  // Проверяем, используется ли mock окружение
  const isMockEnv =
    import.meta.env.DEV && import.meta.env.VITE_USE_MOCK_ENV === 'true'

  try {
    initSDK()
  } catch (error) {
    // В dev режиме игнорируем ошибки инициализации, если окружение не распознано
    if (import.meta.env.DEV) {
      console.warn('SDK initialization error (ignored in dev mode):', error)
    } else {
      throw error
    }
  }

  // Add Eruda if needed.
  // debug && import('eruda')
  //   .then(lib => lib.default.init())
  //   .catch(console.error)

  // Check if all required components are supported.
  if (!backButton.isSupported()) {
    // В dev режиме не выбрасываем ошибку, если компонент не поддерживается
    if (import.meta.env.DEV) {
      console.warn('backButton is not supported (ignored in dev mode)')
    } else {
      throw new Error('ERR_NOT_SUPPORTED')
    }
  }

  // Mount all components used in the project.
  try {
    backButton.mount()
  } catch (e) {
    if (import.meta.env.DEV) {
      console.warn('Failed to mount backButton (ignored in dev mode):', e)
    } else {
      throw e
    }
  }

  try {
    miniApp.mount()
  } catch (e) {
    if (import.meta.env.DEV) {
      console.warn('Failed to mount miniApp (ignored in dev mode):', e)
    } else {
      throw e
    }
  }

  // themeParams.mount()

  try {
    initData.restore()
  } catch (e) {
    if (import.meta.env.DEV) {
      console.warn('Failed to restore initData (ignored in dev mode):', e)
    } else {
      throw e
    }
  }

  // viewport.mount() нельзя вызывать вне Mini Apps
  if (!isMockEnv) {
    void viewport
      .mount()
      .catch(e => {
        console.error('Something went wrong mounting the viewport', e)
      })
      .then(() => {
        // viewport.bindCssVars()
      })
  }

  // Define components-related CSS variables.
  // miniApp.bindCssVars()
  // themeParams.bindCssVars()
}
